/*
 * @Author: your name
 * @Date: 2022-04-12 21:38:06
 * @LastEditTime: 2022-04-15 17:47:41
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /leopard-web-vehicle/src/config/index.js
 */
export const SystemName = '车务中心'
export const TenantIdKey = '_tenant_id'
export const TokenKey = '_yycx_admin'
export const Salt = 'randomsalt'
/*
    mock数据接口
*/
export const mockPrefix = 'http://172.18.160.139:3000/mock/28'
/*
    线上数据接口
*/
export const interfacePrefix = '/admin/v1/vehicle'

/*

*/
export const upLoadZipPrefix = '/admin/v1'

/*
    图片服务地址
*/
export const uploadServiceUrl = 'https://che-test.cheweijia.com'

// 下载批量导入保单模板
export const insurancePolicyTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E4%BF%9D%E5%8D%95%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88v2.xlsx'
// 停复保信息导入模板
export const policyStopOrResumeTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E4%BF%9D%E5%8D%95%E5%81%9C%E5%A4%8D%E4%BF%9D%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'

// 下载批量导入违章记录模板
export const violationRecordTemplate = 'https://server-resource-v4.cheweijia.com/public/common_for_default_file/ce8b3f66275c4addb81b327a99a2bfac/%E8%BF%9D%E7%AB%A0%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFV4.xlsx'

// 客户信息导入模板
export const customerInfoTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E5%AE%A2%E6%88%B7%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 批量新建车辆导入模板
export const carTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E8%BD%A6%E8%BE%86%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%96%87%E4%BB%B6v4.xlsx'

// 下载批量添加车辆模板
export const addCarTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E6%B7%BB%E5%8A%A0%E8%AE%A2%E5%8D%95%E8%BD%A6%E8%BE%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 车辆调拨批量添加车辆模版
export const vehicleTransferAddCarTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E6%B7%BB%E5%8A%A0%E8%B0%83%E6%8B%A8%E8%BD%A6%E8%BE%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 车辆图片导入模板
export const carImgTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E8%BD%A6%E8%BE%86%E5%9B%BE%E7%89%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.zip'

// 客户图片导入模板
export const customerImgTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E5%AE%A2%E6%88%B7%E5%9B%BE%E7%89%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFv2.zip'

// 导入批量调整应收模版
export const batchReceivableChange = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E5%BA%94%E6%94%B6%E6%89%B9%E9%87%8F%E8%B0%83%E6%95%B4%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
// 导入批量调整应收模版
export const paymentTemplate = 'https://server-resource-v4.cheweijia.com/public/common_for_default_file/ce8b3f66275c4addb81b327a99a2bfac/%E6%89%B9%E9%87%8F%E4%BB%98%E6%AC%BE%E6%A8%A1%E6%9D%BF%282%29.xlsx'
export const receivableTemplate = 'https://cheweijia-backend-common-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E6%94%B6%E6%AC%BE%E6%A8%A1%E6%9D%BF%281%29.xlsx'

// 下载维保导入模版
// export const maintenanceTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E7%BB%B4%E4%BF%9D%E4%BF%A1%E6%81%AF%E6%A8%A1%E7%89%88.xlsx'
export const maintenanceTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E7%BB%B4%E4%BF%9D%E4%BF%A1%E6%81%AF%E6%A8%A1%E7%89%88v2.xlsx'
// 下载维保支付项模板
// export const maintenancePayTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E7%BB%B4%E4%BF%9D%E6%94%AF%E4%BB%98%E9%A1%B9%E6%A8%A1%E6%9D%BF.xlsx'
export const maintenancePayTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E7%BB%B4%E4%BF%9D%E6%94%AF%E4%BB%98%E9%A1%B9%E6%A8%A1%E6%9D%BFv3.xlsx'

// 批量金额减免
export const batchAmountRemission = ' https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%BA%94%E6%94%B6%E5%87%8F%E5%85%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 采购订单批量退车模板
export const batchExitCarTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E9%87%87%E8%B4%AD%E6%89%B9%E9%87%8F%E9%80%80%E8%BD%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20.xlsx'

// 初始化企业租赁主订单模版
export const entLeaseOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E4%BC%81%E4%B8%9A%E7%A7%9F%E8%B5%81%E4%B8%BB%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E7%89%88.xlsx'

// 初始化企业租赁子订单模版
export const entLeaseSubOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E4%BC%81%E4%B8%9A%E7%A7%9F%E8%B5%81%E5%AD%90%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E7%89%88.xlsx'

// 已退企业租赁子订单模版
export const entLeaseReutrnSubOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E4%BC%81%E4%B8%9A%E7%A7%9F%E8%B5%81%E5%B7%B2%E9%80%80%E5%AD%90%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E7%89%88.xlsx'

// 采购主订单模版
export const entPurchaseOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E9%87%87%E8%B4%AD%E4%B8%BB%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E6%9D%BF.xlsx'

// 采购在租子订单
export const entPurchaseSubOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E9%87%87%E8%B4%AD%E5%9C%A8%E7%A7%9F%E5%AD%90%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E7%89%88.xlsx'

// 采购已退子订单
export const entPurchaseReturnSubOrderTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E9%87%87%E8%B4%AD%E5%B7%B2%E9%80%80%E5%AD%90%E8%AE%A2%E5%8D%95%E5%88%9D%E5%A7%8B%E5%8C%96%E6%A8%A1%E6%9D%BF.xlsx'

// 客户管理-批量导入客户-个人客户导入模板
export const individualCustomerTemplate = 'https://cheweijia-backend-vehicle-manage-public.oss-cn-shenzhen.aliyuncs.com/public/assert/templates/jaguar/%E4%B8%AA%E4%BA%BA%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 客户管理-批量导入客户-企业客户导入模板
export const enterpriseCustomerTemplate = 'https://cheweijia-backend-vehicle-manage-public.oss-cn-shenzhen.aliyuncs.com/public/assert/templates/jaguar/%E4%BC%81%E4%B8%9A%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

// 事故-批量导入事故信息模板
export const batchImportAccidentTemplate = 'https://yycx-public.oss-cn-shenzhen.aliyuncs.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E4%BA%8B%E6%95%85%E4%BF%A1%E6%81%AF.xlsx'

// 待租-线索管理-销售线索 批量导入线索的线索模版
// 测网
export const salesClueImportTemplateDev = 'https://server-resource-testv2.cheweijia.com/public/common_for_default_file/aa39134a8d834415a3f0afc578f7e1bc/线索批量导入.xlsx'
// 正网
export const salesClueImportTemplateProd = 'https://server-resource-v4.cheweijia.com/public/common_for_default_file/f7f60d157b034953a720bdbfa40e45a9/线索批量导入.xlsx'

// 敏感图片校验类型
export const IMAGE_ILLEGAL_CATEGORIES = {
  riot: '聚众，骚乱',
  normal: '正常文本',
  spam: '含垃圾信息',
  ad: '广告',
  politics: '政治',
  terrorism: '暴恐',
  abuse: '辱骂',
  porn: '色情',
  flood: '灌水',
  contraband: '违禁',
  meaningless: '无意义',
  customized: '自定义（比如命中自定义关键词）',
}
